import { render, staticRenderFns } from "./searchIndi.vue?vue&type=template&id=4c8ddac0"
import script from "./searchIndi.vue?vue&type=script&lang=js"
export * from "./searchIndi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports